// extracted by mini-css-extract-plugin
module.exports = {"terms":"terms_terms__hZkhB","terms_link":"terms_terms_link__0mQCf"};